

export const FrequentlyAskedQuestionsData = [
  {
    title: 'As an interested 3PL partner, what should I expect from the review process?',
    content:
      "During the sign- up process, your company details are collected and reviewed.Our review is typically completed within three business days.Once approved, your designated contact or directors gain access to our Partner application to view shipments ready for dispatch.",
  },
  {
    title: 'What happens if my Partner application is not approved?',
    content:
      'If your 3PL partner application is not approved, it may be due to incomplete or incorrectly submitted information, or your company credentials not meeting our requirements. In such cases, you can contact CML Support via our 24/7 online bot for further clarification.',
  },
  // {
  //   title: 'How are payments made to my business, and what is the remittance schedule?',
  //   content:
  //     'Payments are made in Nigerian Naira on a monthly basis, according to the pre-agreed service rates between your business and CML.',
  // },
];
